<dynamic-form
  [apiName]="apiName"
  [label]="label"
  [group]="formGroup"
  [areaName]="areaName"
  [model]="model"
  [erroremessage]="erroremessage"
  [columns]="columns"
  (cancelChange)="cancel()"
  (submitChange)="save()">
  <ng-container class="content">
    <div class="detail">
      <editable-grid
        *ngIf="ChequeBookDetails && ChequeBookDetails.length > 0"
        #chequeBook
        [isAdd]="false"
        [isDelete]="false"
        [isEdit]="true"
        [height]="40"
        (onRowSelected)="selectedChequeBookRow($event)"
        [columns]="ChequeBookDetails"
        [(dataList)]="model.ChequeBookDetails"
        [DefaultValues]="DefaultValues">
      </editable-grid>
    </div>
  </ng-container>
  <ng-container class="content">
    <div class="action-buttons">
      <ssg-button
        icon="icon-delete_sweep-o"
        buttontype="button"
        (click)="cancelChequeBook()"
        class="action-btn"
        label="ابطال چک"
        [disabled]="model?.ChequeBookDetails?.length <= 0">
      </ssg-button>
      <ssg-button
        icon="icon-delete_sweep-o"
        buttontype="button"
        (click)="returnCancelChequeBook()"
        class="action-btn"
        label="برگشت از ابطال"
        [disabled]="model?.ChequeBookDetails?.length <= 0">
      </ssg-button>
      <ssg-button
        icon="icon-file-document-multiple-outline"
        buttontype="button"
        (click)="createChequeBook()"
        class="action-btn"
        label="ایجاد دسته چک"
        [disabled]="isCreatable()">
      </ssg-button>
    </div>
  </ng-container>
</dynamic-form>
